var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-publish" }, [
    _c("div", { staticClass: "publish-from" }, [
      _c("div", { staticClass: "publish-row" }, [
        _c("span", { staticClass: "lable" }, [_vm._v("类型")]),
        _vm._v(" "),
        _c("div", { staticClass: "radio-group" }, [
          _c(
            "span",
            {
              class: ["radio", { checked: _vm.type == 2 }],
              on: {
                click: function ($event) {
                  _vm.type == 2 ? "" : (_vm.type = 2)
                },
              },
            },
            [_vm._v("二手房")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              class: ["radio", { checked: _vm.type == 3 }],
              on: {
                click: function ($event) {
                  _vm.type == 3 ? "" : (_vm.type = 3)
                },
              },
            },
            [_vm._v("租房")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "publish-row" }, [
        _c("span", { staticClass: "lable" }, [_vm._v("小区名称")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.xq_name,
              expression: "xq_name",
            },
          ],
          staticClass: "value",
          attrs: { type: "text" },
          domProps: { value: _vm.xq_name },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.xq_name = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "publish-row" }, [
        _c("span", { staticClass: "lable" }, [_vm._v("楼栋号")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.loudong,
              expression: "loudong",
            },
          ],
          staticClass: "value",
          attrs: { type: "text" },
          domProps: { value: _vm.loudong },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.loudong = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "publish-row" }, [
        _c("span", { staticClass: "lable" }, [_vm._v("单元号")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.danyuan,
              expression: "danyuan",
            },
          ],
          staticClass: "value",
          attrs: { type: "text" },
          domProps: { value: _vm.danyuan },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.danyuan = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "publish-row" }, [
        _c("span", { staticClass: "lable" }, [_vm._v("门牌号")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.menpaihao,
              expression: "menpaihao",
            },
          ],
          staticClass: "value",
          attrs: { type: "text" },
          domProps: { value: _vm.menpaihao },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.menpaihao = $event.target.value
            },
          },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "btn-submit", on: { click: _vm.submit } }, [
      _vm._v("提交"),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }